import React from "react";
import { useState } from "react";
import dayjs from 'dayjs';
import DataGridCell from "components/dataGridCell";
import DataGridHeader from "components/dataGridHeader";
import {DataGrid, gridColumnPositionsSelector, useGridApiContext, gridPageCountSelector, useGridSelector,gridPaginationRowRangeSelector } from "@mui/x-data-grid";
import CustomNoRowsOverlay from "components/noRowsOverlay/customNoRowsOverlay";

import * as Styled from './Datagrid.styles';
export const Datagrid =({data, properties, ...rest}) => {
    
    const [scrollPositionLeft, setScrollPositionLeft] = React.useState(0);
    const [totalAmountNet, setTotalAmountNet] = React.useState(0);

    const [gridData, setGridData] = useState({
        listDirtyFlag: true,
        invoices: [],
        invoiceColumns: [],
        pagination: {
          totalInvoices: 0,
          rowsPerPageOptions: [25],
          pageSize: 25,
          page: 1,
        },
        filters: {
          fromDate: dayjs().utc(true).startOf('month'),
          toDate: dayjs().utc(true).endOf('month')
        },
        ordering: ['series', 'number'],
        error:false,
        errorMessage:''
      });

    
    const buildColumns = (columns) => {
        let built = [];
        columns.map((column) => {
            built.push({
                field: column.field,
                headerName: column.name,                
                width: column.width,
                headerAlign: 'left',              
                renderHeader: (params) => <DataGridHeader>{params.colDef.headerName}</DataGridHeader>,
                renderCell: (params) => (
                  <DataGridCell main={column.main} rowId={params.row.id}>
                    {params.value}
                  </DataGridCell>)
              });
        });
        return built;    
    }

    const pagination = gridData.pagination;
    const invoices = data;
    const totalAmount = pagination.totalInvoices;
    const invoiceColumns = buildColumns(properties.columns);

    function CustomTotalsComponent(props) {

        const apiRef = useGridApiContext();
        const columnPositionsSelector = gridColumnPositionsSelector(apiRef);
        const rowSelector = gridPaginationRowRangeSelector(apiRef);
        
        const [scrollPositionLeft, setScrollPositionLeft] = React.useState(0);
      
        const column6Width = (columnPositionsSelector[7] - columnPositionsSelector[6]) + 'px';
        const column7Width = (columnPositionsSelector[8] - columnPositionsSelector[7]) + 'px';
      
        const summaryStartPosition = (columnPositionsSelector[6] - scrollPositionLeft - 60) + 'px';
        const viewportWidth = apiRef.current.getRootDimensions()?.viewportInnerSize.width + 'px';
      
        const pageCount = useGridSelector(apiRef, gridPageCountSelector);
        const pagination = apiRef.current.state.pagination;
        const rowsCount = apiRef.current.getVisibleRowModels().size;
      
        const firstRowIndex = rowSelector ? pagination.page*pagination.pageSize + 1 : 0;
        const lastRowIndex = rowSelector ? rowSelector.lastRowIndex+1 : 0;
      
        React.useEffect(() => {
          apiRef.current.subscribeEvent(
            'rowsScroll',
            handleEvent,
          );
        }, []);
    }
    function handleEvent(params) {
        setScrollPositionLeft(params.left);
      }  
    
      
return (
  <Styled.Card>
    <DataGrid
        sx={{ '& > .MuiDataGrid-columnSeparator': { visibility: 'hidden' }, border: 'none', mt: 2 }}        
        name="invoices"
        spacing={10}
        fontSize={13}
        autoHeight={true}
        headerHeight={32}
        rows={invoices}
        rowHeight={64}
        getRowHeight={() => 64}
        columns={invoiceColumns}
        disableSelectionOnClick
        disableColumnFilter
        disableColumnMenu
        checkboxSelection
        pagination
        paginationMode="server"
        rowCount={pagination.totalInvoices}
        rowsPerPageOptions={pagination.rowsPerPageOptions}
        page={pagination.page - 1}
        pageSize={pagination.pageSize}
        onPageChange={(data) => {
        //dispatch(doSetPage(data + 1));
        }}
        experimentalFeatures={{ newEditingApi: true }}
        initialState={{
        sorting: {
            sortModel: [{ field: 'series', sort: 'asc' }],
        },
        }}
        components={{       
        NoRowsOverlay: CustomNoRowsOverlay,
        Footer: CustomTotalsComponent        
        }}
        componentsProps={{
        footer: { totalAmount, totalAmountNet },
        pagination: { labelRowsPerPage: 'Wierszy na stronie' },
        }}       
  />
  </Styled.Card>
)

}